import { createSelector } from 'reselect';
import precise from '../modules/precise';
import getSecondYearFee from '../modules/getSecondYearFee';

const applySecondYearFeeSel = state => state.registration.applySecondYearFee;
const pipeStringSel = state => state.registration.selectedVehicleValue;
const svcTotalSel = state => state.registration.SVCFEE_TOTAL;
const BFfeeSel = state => state.registration.BFfee;
const vehicleWeightSel = state => state.registration.vehicleWeight;
const monthsFromNowSel = state => state.registration.monthsFromNow;
const selectedVehicleTypeSel = state => state.registration.selectedVehicleType;
const vscf12Sel = state => state.registration.vscf12;

const secondYearFeeTotalSelector = createSelector(
  [
    applySecondYearFeeSel,
    pipeStringSel,
    svcTotalSel,
    BFfeeSel,
    vehicleWeightSel,
    monthsFromNowSel,
    selectedVehicleTypeSel,
    vscf12Sel,
  ],
  (applySecondYearFee, pipe, svcFee, BFfee, vehicleWeight, monthsFromNow, selectedVehicleType, vscf12) => {
    const svc = Number(svcFee);

    const total = getSecondYearFee({
      pipe,
      svc,
      BFfee,
      vehicleWeight: vehicleWeight || 0,
      monthsFromNow,
      selectedVehicleType,
      applySecondYearFee,
      vscf12,
    });

    if (applySecondYearFee) {
      return precise(total);
    }
    return precise(0);
  },
);

export default secondYearFeeTotalSelector;
